import { Box, type SelectProps, rem, Text } from '@mantine/core';

export const BookingTimeSelectOption: SelectProps['renderOption'] = ({
  option,
  checked,
}) => {
  const lastestValue = ['23', '55'];

  return (
    <Box
      w="100%"
      py={rem(4)}
      style={{
        borderBottom: lastestValue.includes(option.value)
          ? 'none'
          : '1px solid var(--mantine-color-neutral-2)',
      }}
    >
      <Text
        size="sm"
        fw={500}
        bg={checked ? 'primary.6' : ''}
        c={checked ? 'white' : ''}
        py={rem(8)}
        px="md"
        style={{
          borderRadius: 'var(--mantine-radius-sm)',
        }}
      >
        {option.label}
      </Text>
    </Box>
  );
};
